module.exports = __webpack_public_path__ + "img/social-happyFace.a9f3438c.png";